import { memo } from 'react';

const skeletonBg = 'bg-[rgba(var(--bg-secondary,_31,37,53),0.35)]';

export const PairHeaderSkeleton = memo(() => {
  return (
    <div className="mm-header__header-pair animate-pulse space-y-5" aria-hidden="true">
      <div className="flex flex-wrap items-center gap-3 md:gap-4">
        <div className="flex items-center gap-2 md:gap-3">
          <div className={`h-9 w-24 rounded-full ${skeletonBg}`} />
          <div className={`h-8 w-3 rounded ${skeletonBg}`} />
          <div className={`h-9 w-24 rounded-full ${skeletonBg}`} />
        </div>

        <div className={`h-8 w-8 rounded-full ${skeletonBg}`} />
        <div className={`h-7 w-28 rounded-full ${skeletonBg}`} />
        <div className={`h-10 w-10 rounded-2xl ${skeletonBg}`} />
      </div>

      <div className="flex items-center gap-4">
        <div className={`h-12 w-12 rounded-full ${skeletonBg}`} />
        <div className={`h-4 flex-1 rounded-full ${skeletonBg}`} />
        <div className={`h-4 w-32 rounded-full ${skeletonBg}`} />
      </div>
    </div>
  );
});
